module.exports = __webpack_public_path__ + "img/po-title.0dd70560.png";